// Source: nice-select2.js (https://github.com/bluzky/nice-select2/blob/master/src/js/nice-select2.js)
!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define([], t)
    : 'object' == typeof exports
    ? (exports.Select = t())
    : (e.Select = t());
})(self, function () {
  return (() => {
    'use strict';
    var e = {
        d: (t, i) => {
          for (var s in i)
            e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, { enumerable: !0, get: i[s] });
        },
        o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
        r: e => {
          'undefined' != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
            Object.defineProperty(e, '__esModule', { value: !0 });
        },
      },
      t = {};
    function i(e) {
      var t = document.createEvent('MouseEvents');
      t.initEvent('click', !0, !1), e.dispatchEvent(t);
    }
    function s(e) {
      var t = document.createEvent('HTMLEvents');
      t.initEvent('change', !0, !1), e.dispatchEvent(t);
      var i = document.createEvent('HTMLEvents');
      i.initEvent('input', !0, !1), e.dispatchEvent(i);
    }
    function o(e, t) {
      return e.getAttribute(t);
    }
    function n(e, t) {
      return !!e && e.classList.contains(t);
    }
    function d(e, t) {
      if (e) return e.classList.add(t);
    }
    function r(e, t) {
      if (e) return e.classList.remove(t);
    }
    e.r(t),
      e.d(t, {
        default: () => a,
        bind: () =>
          function (e, t) {
            if (e instanceof NodeList) {
              const i = [];
              for (const s of e) i.push(new a(s, t));
              return i;
            }
            return new a(e, t);
          },
      });
    var l = { data: null, searchable: !1 };
    function a(e, t) {
      (this.el = e.querySelector('select')),
        (this.container = e),
        (this.icon = this.el.parentElement.querySelector('.icon')),
        (this.config = Object.assign({}, l, t || {})),
        (this.data = this.config.data),
        (this.selectedOptions = []),
        (this.placeholder =
          o(this.el, 'placeholder') || this.config.placeholder || 'Select an option'),
        (this.dropdown = null),
        (this.multiple = o(this.el, 'multiple')),
        (this.disabled = o(this.el, 'disabled')),
        this.create();
    }
    return (
      (a.prototype.create = function () {
        (this.el.style.display = 'none'),
          this.icon && (this.icon.style.display = 'none'),
          this.data ? this.processData(this.data) : this.extractData(),
          this.renderDropdown(),
          this.bindEvent();
      }),
      (a.prototype.processData = function (e) {
        var t = [];
        e.forEach(e => {
          t.push({
            data: e,
            attributes: { selected: !1, disabled: !1, optgroup: 'optgroup' == e.value },
          });
        }),
          (this.options = t);
      }),
      (a.prototype.extractData = function () {
        var e = this.el.querySelectorAll('option,optgroup'),
          t = [],
          i = [],
          s = [];
        e.forEach(e => {
          if ('OPTGROUP' == e.tagName) var s = { text: e.label, value: 'optgroup' };
          else s = { text: e.textContent, value: e.value };
          var o = {
            selected: null != e.getAttribute('selected'),
            disabled: null != e.getAttribute('disabled'),
            optgroup: 'OPTGROUP' == e.tagName,
          };
          t.push(s), i.push({ data: s, attributes: o });
        }),
          (this.data = t),
          (this.options = i),
          this.options.forEach(function (e) {
            e.attributes.selected && s.push(e);
          }),
          (this.selectedOptions = s);
      }),
      (a.prototype.renderDropdown = function () {
        var c = this.config.simplified
          ? '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-triangle-down" fill="none" viewBox="0 0 14 6"><path fill="currentColor" d="M7 6 .938 0h12.124L7 6Z"/></svg>'
          : '<svg aria-hidden="true" class="icon icon-caret" viewBox="0 0 10 7"><path d="M1.866.3 5.5 3.928 9.134.3l1.116 1.116-4.75 4.75-4.75-4.75L1.866.301Z" fill="currentColor"/></svg>';
        var e = `<div class="${[
          'fancy-select',
          o(this.el, 'class') || '',
          this.disabled ? 'is-disabled' : '',
          this.multiple ? 'has-multiple' : '',
          this.config.simplified ? 'fancy-select--simplified' : '',
        ].join(' ')}" tabindex="${
          this.disabled ? null : 0
        }">\n  <div class="box" aria-hidden="true">\n    <span class="${
          this.multiple ? 'multiple-options' : 'current'
        }"></span>\n    ${c}\n  </div>\n  <div class="select-dropdown">\n  ${
          this.config.searchable
            ? '<div class="select-search-box">\n<input type="text" class="select-search" placeholder="Search..."/>\n</div>'
            : ''
        }\n  <ul class="list" role="listbox"></ul>\n  </div></div>\n`;
        this.el.insertAdjacentHTML('beforebegin', e),
          (this.dropdown = this.el.previousElementSibling),
          (this.selectDropdown = this.dropdown.querySelector('.select-dropdown')),
          this.selectDropdown.setAttribute('aria-hidden', 'true'),
          this.dropdown.setAttribute('role', 'combobox'),
          this.dropdown.setAttribute('aria-haspopup', 'listbox'),
          this.dropdown.setAttribute('aria-expanded', 'false'),
          function() {
            var labelEl = this.el.id ? document.querySelector('label[for="' + this.el.id + '"]') : null;
            if (labelEl) {
              this.dropdown.setAttribute('aria-label', labelEl.textContent.trim());
            }
          }.call(this),
          function() {
            var listbox = this.dropdown.querySelector('ul[role="listbox"]');
            var labelText = this.dropdown.getAttribute('aria-label');
            if (listbox && labelText) {
              listbox.setAttribute('aria-label', labelText);
            }
          }.call(this),
          (this.current = this.dropdown.querySelector('.current')),
          this._renderSelectedItems(),
          this._renderItems();
      }),
      (a.prototype._renderSelectedItems = function () {
        if (this.multiple) {
          var e = '';
          'auto' == window.getComputedStyle(this.dropdown).width || this.selectedOptions.length < 2
            ? (this.selectedOptions.forEach(function (t) {
                e += `<span class="current">${t.data.text}</span>`;
              }),
              (e = '' == e ? this.placeholder : e))
            : (e = this.selectedOptions.length + ' selected'),
            (this.dropdown.querySelector('.multiple-options').innerHTML = e);
        } else {
          var t =
            this.selectedOptions.length > 0 ? this.selectedOptions[0].data.text : this.placeholder;
          this.current.innerHTML = t;
          this.current.classList.toggle('is-placeholder', !this.selectedOptions.length);
        }
      }),
      (a.prototype._renderItems = function () {
        var e = this.dropdown.querySelector('ul');
        this._itemIndex = 0;
        this.options.forEach(t => {
          e.appendChild(this._renderItem(t));
        });
      }),
      (a.prototype._renderItem = function (e) {
        var t = document.createElement('li');
        if (((t.innerHTML = e.data.text), e.attributes.optgroup)) t.classList.add('optgroup');
        else {
          var uid = (this.el.id || 'select') + '-option-' + this._itemIndex++;
          t.setAttribute('id', uid);
          t.setAttribute('data-value', e.data.value);
          t.setAttribute('role', 'option');
          t.setAttribute('tabindex', '-1');
          t.setAttribute('aria-selected', e.attributes.selected ? 'true' : 'false');
          var i = [
            'option',
            e.attributes.selected ? 'selected' : null,
            e.attributes.disabled ? 'is-disabled' : null,
          ].filter(Boolean);
          t.addEventListener('click', this._onItemClicked.bind(this, e)), t.classList.add(...i);
        }
        return (e.element = t), t;
      }),
      (a.prototype.update = function () {
        if ((this.extractData(), this.dropdown)) {
          var e = n(this.dropdown, 'is-open');
          this.dropdown.parentNode.removeChild(this.dropdown), this.create(), e && i(this.dropdown);
        }
      }),
      (a.prototype.disable = function () {
        this.disabled || ((this.disabled = !0), d(this.dropdown, 'is-disabled'));
      }),
      (a.prototype.enable = function () {
        this.disabled && ((this.disabled = !1), r(this.dropdown, 'is-disabled'));
      }),
      (a.prototype.clear = function () {
        (this.selectedOptions = []),
          this._renderSelectedItems(),
          this.updateSelectValue(),
          s(this.el);
      }),
      (a.prototype.destroy = function () {
        this.dropdown &&
          (this.dropdown.parentNode.removeChild(this.dropdown), (this.el.style.display = ''), this.icon && (this.icon.style.display = ''));
      }),
      (a.prototype.bindEvent = function () {
        this.dropdown.addEventListener('click', this._onClicked.bind(this)),
          this.dropdown.addEventListener('keydown', this._onKeyPressed.bind(this)),
          this.dropdown.addEventListener('focusout', this._onFocusOut.bind(this)),
          this.dropdown.addEventListener(
            'focusin',
            function (e) {
              var t = document.createEvent('FocusEvent');
              t.initEvent('focusin', !0, !1), e.dispatchEvent(t);
            }.bind(this, this.el)
          ),
          this.dropdown.addEventListener(
            'focusout',
            function (e) {
              var t = document.createEvent('FocusEvent');
              t.initEvent('focusout', !0, !1), e.dispatchEvent(t);
            }.bind(this, this.el)
          ),
          window.addEventListener('click', this._onClickedOutside.bind(this)),
          this.config.searchable && this._bindSearchEvent();
      }),
      (a.prototype._bindSearchEvent = function () {
        var e = this.dropdown.querySelector('.select-search');
        e &&
          e.addEventListener('click', function (e) {
            return e.stopPropagation(), !1;
          }),
          e.addEventListener('input', this._onSearchChanged.bind(this));
      }),
      (a.prototype._onClicked = function (e) {
        if (
          (this.multiple
            ? (this.container.classList.add('is-open'), this.dropdown.classList.add('is-open'))
            : (this.container.classList.toggle('is-open'), this.dropdown.classList.toggle('is-open')),
          this.dropdown.setAttribute('aria-expanded', this.dropdown.classList.contains('is-open') ? 'true' : 'false'),
          this.selectDropdown.setAttribute('aria-hidden', this.dropdown.classList.contains('is-open') ? 'false' : 'true'),
          this.dropdown.classList.contains('is-open'))
        ) {
          var t = this.dropdown.querySelector('.select-search');
          t && ((t.value = ''), t.focus());
          var i = this.dropdown.querySelector('.focus');
          r(i, 'focus'),
            d((i = this.dropdown.querySelector('.selected') || this._findNext(null)), 'focus'),
            this._updateActiveDescendant(i),
            this.dropdown.querySelectorAll('ul li').forEach(function (e) {
              e.style.display = '';
            });
          if (!t && i) i.focus();
        } else {
          this._updateActiveDescendant(null);
          this.dropdown.focus();
        }
      }),
      (a.prototype._onItemClicked = function (e, t) {
        var i = t.target;
        n(i, 'is-disabled') ||
          (this.multiple
            ? n(i, 'selected')
              ? (r(i, 'selected'),
                i.setAttribute('aria-selected', 'false'),
                this.selectedOptions.splice(this.selectedOptions.indexOf(e), 1),
                (this.el.querySelector('option[value="' + i.dataset.value + '"]').selected = !1))
              : (d(i, 'selected'), i.setAttribute('aria-selected', 'true'), this.selectedOptions.push(e))
            : (this.selectedOptions.forEach(function (e) {
                r(e.element, 'selected');
                e.element.setAttribute('aria-selected', 'false');
              }),
              d(i, 'selected'),
              i.setAttribute('aria-selected', 'true'),
              (this.selectedOptions = [e])),
          this._renderSelectedItems(),
          this.updateSelectValue());
      }),
      (a.prototype.updateSelectValue = function () {
        if (this.multiple) {
          var e = this.el;
          this.selectedOptions.forEach(function (t) {
            var i = e.querySelector('option[value="' + t.data.value + '"]');
            i && i.setAttribute('selected', !0);
          });
        } else
          this.selectedOptions.length > 0 && (this.el.value = this.selectedOptions[0].data.value);
        s(this.el);
      }),
      (a.prototype._onFocusOut = function (e) {
        var self = this;
        setTimeout(function() {
          if (!self.dropdown.contains(document.activeElement)) {
            self.dropdown.classList.remove('is-open');
            self.container.classList.remove('is-open');
            self.dropdown.setAttribute('aria-expanded', 'false');
            self.selectDropdown.setAttribute('aria-hidden', 'true');
            self._updateActiveDescendant(null);
          }
        }, 0);
      }),
      (a.prototype._onClickedOutside = function (e) {
        this.dropdown.contains(e.target) ||
          this.container.contains(e.target) ||
          e.target == this.el ||
          (this.dropdown.classList.remove('is-open'), this.container.classList.remove('is-open'), this.dropdown.setAttribute('aria-expanded', 'false'), this.selectDropdown.setAttribute('aria-hidden', 'true'));
      }),
      (a.prototype._updateActiveDescendant = function (e) {
        e && e.id
          ? this.dropdown.setAttribute('aria-activedescendant', e.id)
          : this.dropdown.removeAttribute('aria-activedescendant');
      }),
      (a.prototype._onKeyPressed = function (e) {
        var t = this.dropdown.querySelector('.focus'),
          s = this.dropdown.classList.contains('is-open');
        if (32 == e.keyCode || 13 == e.keyCode) {
          e.preventDefault();
          i(s ? t : this.dropdown);
        }
        else if (40 == e.keyCode || (9 == e.keyCode && !e.shiftKey && s)) {
          // Down arrow or Tab when open: move to next option
          e.preventDefault();
          if (s) {
            var o = this._findNext(t);
            if (!o) o = this._findNext(null); // wrap to first
            if (o) {
              r(this.dropdown.querySelector('.focus'), 'focus');
              d(o, 'focus');
              this._updateActiveDescendant(o);
              o.focus();
              o.scrollIntoView({ block: 'nearest' });
            }
          } else i(this.dropdown);
        } else if (38 == e.keyCode || (9 == e.keyCode && e.shiftKey && s)) {
          // Up arrow or Shift+Tab when open: move to previous option
          e.preventDefault();
          if (s) {
            var n = this._findPrev(t);
            if (!n) n = this._findPrev(null); // wrap to last
            if (n) {
              r(this.dropdown.querySelector('.focus'), 'focus');
              d(n, 'focus');
              this._updateActiveDescendant(n);
              n.focus();
              n.scrollIntoView({ block: 'nearest' });
            }
          } else i(this.dropdown);
        } else if (27 == e.keyCode && s) {
          e.preventDefault();
          i(this.dropdown);
        } else if (36 == e.keyCode && s) {
          // Home key: move to first option
          e.preventDefault();
          var first = this._findNext(null);
          if (first) {
            r(this.dropdown.querySelector('.focus'), 'focus');
            d(first, 'focus');
            this._updateActiveDescendant(first);
            first.focus();
            first.scrollIntoView({ block: 'nearest' });
          }
        } else if (35 == e.keyCode && s) {
          // End key: move to last option
          e.preventDefault();
          var last = this._findPrev(null);
          if (last) {
            r(this.dropdown.querySelector('.focus'), 'focus');
            d(last, 'focus');
            this._updateActiveDescendant(last);
            last.focus();
            last.scrollIntoView({ block: 'nearest' });
          }
        }
        return !1;
      }),
      (a.prototype._findNext = function (e) {
        for (e = e ? e.nextElementSibling : this.dropdown.querySelector('.list .option'); e; ) {
          if (!n(e, 'is-disabled') && 'none' != e.style.display) return e;
          e = e.nextElementSibling;
        }
        return null;
      }),
      (a.prototype._findPrev = function (e) {
        for (
          e = e
            ? e.previousElementSibling
            : this.dropdown.querySelector('.list .option:last-child');
          e;

        ) {
          if (!n(e, 'is-disabled') && 'none' != e.style.display) return e;
          e = e.previousElementSibling;
        }
        return null;
      }),
      (a.prototype._onSearchChanged = function (e) {
        var t = this.dropdown.classList.contains('is-open'),
          i = e.target.value;
        if ('' == (i = i.toLowerCase()))
          this.options.forEach(function (e) {
            e.element.style.display = '';
          });
        else if (t) {
          var s = new RegExp(i);
          this.options.forEach(function (e) {
            var t = e.data.text.toLowerCase(),
              i = s.test(t);
            e.element.style.display = i ? '' : 'none';
          });
        }
        this.dropdown.querySelectorAll('.focus').forEach(function (e) {
          r(e, 'focus');
        }),
          d(this._findNext(null), 'focus');
      }),
      t
    );
  })();
});
